import { motion } from "motion/react";

// SVG paths for the Era logo loader animation
const SVG_PATHS = {
	// Purple ring/circle progressbar path
	ring: "M108.993 32.0596C108.423 30.3991 107.226 28.3999 106.289 26.9638C105.452 25.6799 105.692 25.3871 107.063 26.0732C118.003 31.549 128.46 38.635 132.903 44.2449C137.903 50.5577 137.956 56.1825 133.054 60.189C128.152 64.1955 118.589 66.3435 105.946 66.2775C93.3028 66.2116 78.3381 63.9358 63.5274 59.8265C48.7167 55.7173 34.9477 50.0209 24.4981 43.6797C14.0485 37.3386 7.54475 30.7327 6.06267 24.9549C4.58059 19.1772 8.20906 14.5738 16.3478 11.9064C24.0309 9.38835 44.5004 9.50893 44.5004 10.0089C44.5004 10.5089 37.5004 15.8803 36.5004 16.6271C35.5004 17.3738 34.7017 16.868 30.0647 18.3877C23.9606 20.3883 21.2393 23.8408 22.3509 28.1741C23.4624 32.5074 28.3403 37.4619 36.1774 42.2177C44.0146 46.9736 54.3414 51.2459 65.4494 54.3278C76.5574 57.4097 87.7809 59.1166 97.2631 59.1661C106.745 59.2155 113.918 57.6045 117.595 54.5996C121.271 51.5948 121.231 47.3761 117.481 42.6416C114.716 39.1509 109.942 36.8267 109.967 36.1931C109.993 35.5596 109.531 33.6283 108.993 32.0596Z",
	// Black Era logo path
	logo: "M67.9089 3.05957C43.9314 3.05957 24.4907 22.5002 24.4907 46.4778C24.4907 70.4554 43.9314 89.896 67.9089 89.896C91.8865 89.896 111.327 70.4554 111.327 46.4778C111.327 22.5002 91.8922 3.05957 67.9089 3.05957ZM90.7239 75.9621C82.8581 81.8657 72.9563 85.3194 63.1565 84.4914C54.6782 83.7712 46.3926 79.6086 41.1809 72.9507C40.3699 71.9129 39.6383 70.8183 38.9861 69.6671C37.6194 67.2398 36.6156 64.5461 36.5816 61.7615C36.5475 58.977 37.5684 56.1017 39.6894 54.2983C42.8539 51.6102 47.4588 51.854 51.5874 51.3607C58.5005 50.5327 65.079 47.13 69.7464 41.9636C73.3362 37.9938 75.7862 33.0882 79.3987 29.1355C89.8959 17.6571 103.28 26.2659 105.758 39.5987C107.442 48.6442 105.458 58.3135 100.354 65.9638C97.7732 69.8316 94.4442 73.1719 90.7239 75.9621Z",
};

interface LoaderAnimationProps {
	size?: number;
}

export function LoaderAnimation({ size = 128 }: LoaderAnimationProps) {
	// Scale factor based on original viewBox (142x90) and desired size
	const aspectRatio = 142 / 90;
	const width = size * aspectRatio;
	const height = size;

	return (
		<div style={{ width: `${width}px`, height: `${height}px` }}>
			<svg
				fill="none"
				preserveAspectRatio="xMidYMid meet"
				viewBox="0 0 142 90"
				style={{ display: "block", width: "100%", height: "100%" }}
				role="img"
				aria-label="Loading"
			>
				<g clipPath="url(#clip0_loader)" id="loader-group">
					{/* Black logo - static */}
					<path d={SVG_PATHS.logo} fill="black" id="logo-path" />

					{/* Purple ring with animated gradient */}
					<g id="circle-progressbar">
						<path d={SVG_PATHS.ring} fill="url(#paint0_loader)" />
					</g>
				</g>
				<defs>
					<motion.linearGradient
						gradientUnits="userSpaceOnUse"
						id="paint0_loader"
						initial={{
							x1: 76.9291,
							y1: 16.5299,
							x2: 65.1923,
							y2: 60.3322,
						}}
						animate={{
							x1: [76.9291, 65.1923, 55, 65.1923, 76.9291, 88, 76.9291],
							y1: [16.5299, 60.3322, 45, 29.6777, 16.5299, 45, 16.5299],
							x2: [65.1923, 76.9291, 88, 76.9291, 65.1923, 55, 65.1923],
							y2: [60.3322, 16.5299, 45, 60.3322, 60.3322, 45, 60.3322],
						}}
						transition={{
							duration: 3,
							ease: "linear",
							repeat: Number.POSITIVE_INFINITY,
						}}
					>
						<stop stopColor="#DEDFFF" />
						<stop offset="0.5" stopColor="#7F7BFF" />
						<stop offset="1" stopColor="#DEDFFF" />
					</motion.linearGradient>
					<clipPath id="clip0_loader">
						<rect fill="white" height="89.896" width="141.871" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
}
